import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@blaze-cms/nextjs-components';
import { TRANSLATION_NAMESPACE } from '../../constants';

const FlyOutBasketSummary = ({ className, totalItems, formattedTotal }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const summaryClassName = `${className}__summary`;

  return (
    <div className={summaryClassName}>
      <span className={`${summaryClassName}__total-items`}>
        {t('TOTAL_ITEMS')}: {totalItems}
      </span>
      {formattedTotal && (
        <span className={`${summaryClassName}__subtotal`}>
          {t('SUBTOTIAL_EXCLUDING_DELIVERY_TAX')}: {formattedTotal}
        </span>
      )}
    </div>
  );
};

FlyOutBasketSummary.propTypes = {
  className: PropTypes.string.isRequired,
  totalItems: PropTypes.string,
  formattedTotal: PropTypes.string
};

FlyOutBasketSummary.defaultProps = {
  totalItems: '0',
  formattedTotal: '0'
};

export default FlyOutBasketSummary;
